var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        {
          attrs: { left: "", color: "transparent" },
          on: {
            change: function($event) {
              return _vm.cargaNotificaciones()
            }
          },
          model: {
            value: _vm.tabModel,
            callback: function($$v) {
              _vm.tabModel = $$v
            },
            expression: "tabModel"
          }
        },
        [
          _c("v-tab", { attrs: { href: "#0" } }, [_vm._v("Activas")]),
          _c("v-tab", { attrs: { href: "#1" } }, [_vm._v("Todas")])
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.validForm,
            callback: function($$v) {
              _vm.validForm = $$v
            },
            expression: "validForm"
          }
        },
        [
          _c(
            "v-layout",
            [
              _vm.tabModel === "0"
                ? _c(
                    "v-flex",
                    {
                      staticStyle: { "padding-top": "22px" },
                      attrs: { xs12: "", md8: "", lg8: "" }
                    },
                    [
                      _c("h2", { staticClass: "h2_title" }, [
                        _vm._v("Notificaciones Activas")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.tabModel === "1"
                ? _c(
                    "v-flex",
                    {
                      staticStyle: { "padding-top": "22px" },
                      attrs: { xs12: "", md8: "", lg8: "" }
                    },
                    [
                      _c("h2", { staticClass: "h2_title" }, [
                        _vm._v("Todas las Notificaciones")
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm.tabModel === "1"
            ? _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md2: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Color de tipicación",
                          items: _vm.Colores,
                          "no-data-text": "Sin resultados",
                          "prepend-icon": "",
                          dense: "",
                          multiple: "",
                          "small-chips": ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "prepend-item",
                              fn: function() {
                                return [
                                  _c(
                                    "v-list-tile",
                                    [
                                      _c("v-checkbox", {
                                        attrs: { label: "Seleccionar todos" },
                                        on: {
                                          change: function($event) {
                                            return _vm.selectAllColor()
                                          }
                                        },
                                        model: {
                                          value: _vm.checkAllColor,
                                          callback: function($$v) {
                                            _vm.checkAllColor = $$v
                                          },
                                          expression: "checkAllColor"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("v-divider")
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "selection",
                              fn: function(ref) {
                                var item = ref.item
                                var index = ref.index
                                return [
                                  index === 0
                                    ? _c("v-chip", [
                                        _c("span", [_vm._v(_vm._s(item))])
                                      ])
                                    : _vm._e(),
                                  index === 1
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "grey--text text-caption",
                                          staticStyle: { "font-size": "0.75em" }
                                        },
                                        [
                                          _vm._v(
                                            "\n              (+" +
                                              _vm._s(
                                                _vm.alertaColor.length - 1
                                              ) +
                                              ")\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1413605730
                        ),
                        model: {
                          value: _vm.alertaColor,
                          callback: function($$v) {
                            _vm.alertaColor = $$v
                          },
                          expression: "alertaColor"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md2: "", lg2: "" } },
                    [
                      _c("DatePicker", {
                        attrs: { label: "Fecha Desde", max: _vm.fechaMaxima },
                        model: {
                          value: _vm.fechaDesde,
                          callback: function($$v) {
                            _vm.fechaDesde = $$v
                          },
                          expression: "fechaDesde"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md2: "", lg2: "" } },
                    [
                      _c("DatePicker", {
                        attrs: { label: "Fecha Hasta", max: _vm.fechaMaxima },
                        model: {
                          value: _vm.fechaHasta,
                          callback: function($$v) {
                            _vm.fechaHasta = $$v
                          },
                          expression: "fechaHasta"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md3: "", lg1: "" } },
                    [
                      _c("TimePicker", {
                        attrs: { label: "Hora Desde" },
                        model: {
                          value: _vm.horaDesde,
                          callback: function($$v) {
                            _vm.horaDesde = $$v
                          },
                          expression: "horaDesde"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md3: "", lg1: "" } },
                    [
                      _c("TimePicker", {
                        attrs: { label: "Hora Hasta" },
                        model: {
                          value: _vm.horaHasta,
                          callback: function($$v) {
                            _vm.horaHasta = $$v
                          },
                          expression: "horaHasta"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md3: "", lg2: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Nombre de alerta",
                          items: _vm.buscarAlerta,
                          "item-text": "nombre",
                          "item-value": "nombre",
                          "no-data-text": "Sin resultados",
                          dense: "",
                          multiple: "",
                          "small-chips": ""
                        },
                        on: { change: _vm.valideListAlert },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "prepend-item",
                              fn: function() {
                                return [
                                  _c(
                                    "v-list-tile",
                                    [
                                      _c("v-checkbox", {
                                        attrs: { label: "Seleccionar todos" },
                                        on: {
                                          change: function($event) {
                                            return _vm.selectAllAlerta()
                                          }
                                        },
                                        model: {
                                          value: _vm.checkAllAlerta,
                                          callback: function($$v) {
                                            _vm.checkAllAlerta = $$v
                                          },
                                          expression: "checkAllAlerta"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("v-divider")
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "selection",
                              fn: function(ref) {
                                var item = ref.item
                                var index = ref.index
                                return [
                                  index === 0
                                    ? _c("v-chip", [
                                        _c("span", [
                                          _vm._v(_vm._s(item.nombre))
                                        ])
                                      ])
                                    : _vm._e(),
                                  index === 1
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "grey--text text-caption",
                                          staticStyle: { "font-size": "0.75em" }
                                        },
                                        [
                                          _vm._v(
                                            "\n              (+" +
                                              _vm._s(
                                                _vm.alertaNombre.length - 1
                                              ) +
                                              ")\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1152088433
                        ),
                        model: {
                          value: _vm.alertaNombre,
                          callback: function($$v) {
                            _vm.alertaNombre = $$v
                          },
                          expression: "alertaNombre"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md3: "", lg1: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Unidad",
                          items: _vm.Vehiculo,
                          "item-text": "unidad",
                          "item-value": "id",
                          "no-data-text": "Sin resultados",
                          dense: "",
                          multiple: "",
                          "small-chips": ""
                        },
                        on: { change: _vm.valideListPatent },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "prepend-item",
                              fn: function() {
                                return [
                                  _c(
                                    "v-list-tile",
                                    [
                                      _c("v-checkbox", {
                                        attrs: { label: "Seleccionar todos" },
                                        on: {
                                          change: function($event) {
                                            return _vm.selectAll()
                                          }
                                        },
                                        model: {
                                          value: _vm.checkAll,
                                          callback: function($$v) {
                                            _vm.checkAll = $$v
                                          },
                                          expression: "checkAll"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("v-divider")
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "selection",
                              fn: function(ref) {
                                var item = ref.item
                                var index = ref.index
                                return [
                                  index === 0
                                    ? _c("v-chip", [
                                        _c("span", [
                                          _vm._v(_vm._s(item.unidad))
                                        ])
                                      ])
                                    : _vm._e(),
                                  index === 1
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "grey--text text-caption",
                                          staticStyle: { "font-size": "0.75em" }
                                        },
                                        [
                                          _vm._v(
                                            "\n              (+" +
                                              _vm._s(
                                                _vm.buscarAlertaPatente.length -
                                                  1
                                              ) +
                                              ")\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2421965737
                        ),
                        model: {
                          value: _vm.buscarAlertaPatente,
                          callback: function($$v) {
                            _vm.buscarAlertaPatente = $$v
                          },
                          expression: "buscarAlertaPatente"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.tabModel === "1"
                    ? _c("v-flex", { attrs: { xs12: "", sm6: "", md1: "" } }, [
                        _c(
                          "div",
                          { staticClass: "text-xs-center", staticStyle: {} },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  flat: "",
                                  icon: "",
                                  small: "",
                                  disabled: !_vm.validForm
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  { on: { click: _vm.onFilterTextBoxChanged } },
                                  [_vm._v("search")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              { attrs: { flat: "", icon: "", small: "" } },
                              [
                                _c(
                                  "v-icon",
                                  { on: { click: _vm.clearFilters } },
                                  [_vm._v("clear")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _c("v-divider"),
          _c("v-flex", { attrs: { md12: "" } }, [
            _c(
              "div",
              { staticClass: "gridcard rounded-card" },
              [
                _c("ag-grid-vue", {
                  staticClass: "ag-theme-material",
                  staticStyle: {
                    width: "100%",
                    height: "auto",
                    "font-family": "'Asap', sans-serif"
                  },
                  attrs: { gridOptions: _vm.gridOptions }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c("ContactosNotificados", {
        attrs: { show: _vm.muestraNotificados, id: _vm.idNotificacion },
        on: {
          modalAsociacionEmit: function($event) {
            return _vm.notificadosModalCallback($event)
          }
        }
      }),
      _c("DetalleNotificacion", {
        attrs: { show: _vm.muestraDetalleNotificacion, id: _vm.idNotificacion },
        on: {
          modalDetalleEmit: function($event) {
            return _vm.detallesModalCallback($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }